export enum TyreRimType {
  Steel = 'steel',
  Alloy = 'alloy',
  Other = 'other'
}
